import { Page, PageHeader } from "@dash/page";

import { useClientManager } from "@megaron/react-clients";

import { SyncBar } from "./SyncBar";
import { SyncResultView } from "./SyncResultsView";

export const ExportBcItemsPage = () => {
  const query = useClientManager("catalog").exportBcItems().useQuery({
    dryRun: true,
  });

  const commitMutation = useClientManager("catalog").exportBcItems().useMutation();

  const commit = async () => {
    const result = await commitMutation.mutateAsync({
      dryRun: false,
    });
  };

  return (
    <Page css={{ maxWidth: "100%", gap: "1rem", display: "flex", flexDirection: "column" }}>
      <PageHeader>Eksportuj zapasy do BC</PageHeader>
      <SyncBar
        onCommit={commit}
        isLoading={query.isLoading || commitMutation.isLoading}
        isDisabled={!query.data?.operations.length}
      />

      <SyncResultView
        isLoading={query.isLoading}
        result={query.data}
        labels={{
          itemId: "Id",
          gtin: "EAN",
          itemName: "Nazwa",
        }}
      />
    </Page>
  );
};
